<script>
    import { flip } from 'svelte/animate';
    import { crossfade } from 'svelte/transition';
    import { tcc_json } from '$lib/static/tcc_json.js';
    import { tooltip } from '$lib/app/tooltip.js';
    import { expoOut } from 'svelte/easing';

    let { 
        user_tcc,
        size = 32,
    } = $props();

    const [send, receive] = crossfade({});
    //import { crossfade } from 'svelte/transition';
    
    //import { quintOut } from 'svelte/easing';

    /*
    export const [send, receive] = crossfade({
        duration: (d) => Math.sqrt(d * 1200),

        fallback(node, params) {
            const style = getComputedStyle(node);
            const transform = style.transform === 'none' ? '' : style.transform;

            return {
                duration: 1200,
                easing: quintOut,
                css: (t) => `
                    transform: ${transform} scale(${t});
                `
                //                    opacity: ${t}

            };
        }
    });*/

    const tcc_to_continents = {
        "AFR": "Africa",
        "ANT": "Antarctica",
        "ASI": "Asia", "MID": "Asia",
        "CAM": "North America", "CRB": "North America", "NAM": "North America",
        "EUR": "Europe",
        "PAC": "Australia and Oceania",
        "SAM": "South America"
    };

    const continents_i = {
        "Europe": "europe.png",
        "North America": "north-america.png",
        "Asia": "asia.png",
        "Africa": "africa.png",
        "South America": "south-america.png",
        "Australia and Oceania": "australia.png",
        "Antarctica": "antarctica.png"
    }

    let visited_continents = $derived.by(() => {
        let visited_continents = {};
        if(user_tcc) {
            for (const reg of tcc_json) {
                if(!visited_continents[tcc_to_continents[reg.reg]]) {
                    visited_continents[tcc_to_continents[reg.reg]] = reg.db.some((x) => user_tcc[x.id] > 0);
                }
            }
        }
        return visited_continents;
    });

    let continents_arr = $derived.by(() => {
        const continents_arr = Object.keys(continents_i).map(continent => {
            return {
                id: continent,
                visited: !!visited_continents[continent],
                url: visited_continents[continent] ? '/i/c/'+continents_i[continent] : '/i/bw/'+continents_i[continent]
            };
        });

        return [
            ...continents_arr.filter(c => c.visited),
            ...continents_arr.filter(c => !c.visited)
        ];
    });
</script>
<!--span>
    <span>
        {#each Object.keys(continents_i).filter(i => continents[i]) as j (j)}
            <span   use:tooltip
                    id={j}
                    data-tooltip='{j} ✓'
                    animate:flip
                    in:receive={{key: j}} 
                    out:send={{key: j}}><img src={'/i/c/'+continents_i[j]} alt='{j} ✓' width={size} height={size}/></span>
        {/each}
    </span>
    <span>
        {#each Object.keys(continents_i).filter(i => !continents[i]) as j (j)}
            <span   use:tooltip
                    id={j}
                    data-tooltip='{j} ❌' 
                    animate:flip 
                    in:receive={{key: j}} 
                    out:send={{key: j}}><img src={'/i/bw/'+continents_i[j]} alt='{j} ×' width={size} height={size}/></span>
        {/each}
    </span>


    in:receive={{key: j}} 
                    out:send={{key: j}}
</span-->

<!--div>
        {#each Object.keys(continents_i).filter(i => continents[i]) as j (j)}
            <span   use:tooltip
                    data-tooltip='{j} ✓'
                    animate:flip={{duration:400, easing:sineInOut}}
            ><img src={'/i/c/'+continents_i[j]} alt='{j} ✓' width={size} height={size}/></span>
        {/each}

        {#each Object.keys(continents_i).filter(i => !continents[i]) as j (j)}
            <span   use:tooltip
                    data-tooltip='{j} ❌' 
                    animate:flip={{duration:400, easing:sineInOut}}
            ><img src={'/i/bw/'+continents_i[j]} alt='{j} ×' width={size} height={size}/></span>
        {/each}
</div-->

<div class="container">
    {#each continents_arr as continent (continent.id)}
        <span   use:tooltip
                data-tooltip='{continent.id} ✓'
                animate:flip={{duration:400, easing:expoOut}}
        ><img src={continent.url} alt='{continent.id} ✓' width={size} height={size}/></span>
    {/each}  
</div>


<style>
.container {
    display: inline-flex;
    flex-direction: row;
    flex-wrap: nowrap;
}
</style>
